import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloFollajeArtificial from '../components/sections/FollajeArtificial/TituloFollajeArtificial';
import IntroFollajeArtificial from '../components/sections/FollajeArtificial/IntroFollajeArtificial';
import EspecificacionesFollaje from '../components/sections/FollajeArtificial/EspecificacionesFollaje';
import FollajeTabs from '../components/sections/FollajeArtificial/FollajeTabs';
import AplicacionesFollaje from '../components/sections/FollajeArtificial/AplicacionesFollaje';
import CaracteristicasFollaje from '../components/sections/FollajeArtificial/CaracteristicasFollaje';
import BarraInfoNosotros from '../components/sections/BarraInfoNosotros';
import FormularioContactoFollaje from '../components/sections/FollajeArtificial/FormularioContactoFollaje';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const FollajeArtificialPage = () => {
    return (
        <div>
            <SeoMetadata
                title="Follaje Artificial para Muros y Fachadas | Decototal"
                description="Decora muros, terrazas y fachadas con follaje artificial. Explora modelos estándar, premium y 3D, y solicita una cotización."
                keywords="follaje artificial, muro verde artificial, jardín vertical artificial, follaje para fachadas"
                path="/follaje-artificial"
                image="/assets/img/productos/follaje-artificial/follaje-artificial-titulo.jpg"
            />
            <Header />
            <TituloFollajeArtificial />
            <IntroFollajeArtificial />

            {/* 1. Ayuda a decidir la categoría ANTES de mostrar el catálogo completo */}
            <EspecificacionesFollaje />

            {/* 2. Catálogo de modelos, ya con contexto de qué categoría le conviene */}
            <FollajeTabs />

            {/* 3. Inspira con casos de uso reales después de ver tanto producto */}
            <AplicacionesFollaje />

            {/* 4. Refuerza el "por qué comprar" justo antes de la conversión */}
            <CaracteristicasFollaje />

            {/* 5. Confianza de marca */}
            <BarraInfoNosotros backgroundImage="/assets/img/productos/follaje-artificial/follaje-artificial-background.jpg" />

            {/* 6. Conversión */}
            <FormularioContactoFollaje />
            <Footer />
        </div>
    );
};

export default FollajeArtificialPage;